export default "__VITE_PUBLIC_ASSET__1686e55f__"